module.exports = __webpack_public_path__ + "img/Empty.9efcb60d.png";